import { gradientGrainStyling } from "$/util/background";
import { Box, Button, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import analytics from "../util/analytics";
import { useAuth } from "../util/auth";

const ads = {
  join: {
    title: {
      // start_creating: "Start creating your next tattoo with AI",
      // create_tattoo: "Create your next tattoo with AI",
      ai_tattoo_generator: "AI Tattoo Generator",
    },
    body: (
      <>
        <Typography>
          Try the BlackInk AI tattoo generator to create your next tattoo design in
          seconds.
        </Typography>

        <Typography component="ul">
          <li>AI Tattoo Generator</li>
          <li>Image-to-Stencil</li>
          <li>4x Super Resolution Download</li>
        </Typography>
      </>
    ),
    button: {
      try_free: "Try for Free",
      // join_Free: "Join for Free",
      get_started: "Get Started",
    },
    link: "/",
    img: {
      src: "/images/pro_badge.svg",
      alt: "Pro Badge",
      width: 45,
      height: 79,
    },
    bgColor: "#574eeb",
    buttonColor: "warning",
    textColor: "#fff",
  },
  upgrade: {
    title: {
      // get_pro: 'Get "Pro Unlimited" and unlock all features',
      // pro_features: 'Unlock all features with "Pro Unlimited"',
      create_unlimited: 'Create unlimited tattoos with "Pro"',
    },
    body: (
      <>
        <Typography sx={{ mt: 2 }}>
          <strong>Get unlimited access</strong> to all AI features:
        </Typography>

        <Typography component="ul">
          <li>AI tattoo generator</li>
          <li>Templates by placement (sleeves, body parts, etc)</li>
          <li>Control tattoo complexity, colors, line weight, etc</li>
          <li>Image-to-stencil converter</li>
          <li>4x super resolution download</li>
          <li>Unlock all 4 images while browsing</li>
        </Typography>
      </>
    ),
    button: {
      // upgrade: "Upgrade to Pro",
      // join_pro: "Join Pro",
      start_creating: "Start Creating",
      // pricing: "View Pricing",
    },
    link: "/pricing",
    img: {
      src: "/images/pro_badge.svg",
      alt: "Pro Badge",
      width: 45,
      height: 79,
    },
    bgColor: "#574eeb",
    buttonColor: "warning",
    textColor: "#fff",
  },
};

function Banner() {
  const [selectedBannerTitle, setSelectedBannerTitle] = useState("");
  const [selectedBannerButton, setSelectedBannerButton] = useState("");
  const auth = useAuth();
  let selectedBannerId = null;
  if (auth.user && auth.user.isActiveSubscription) {
    selectedBannerId = null;
  } else if (auth.user) {
    selectedBannerId = "upgrade";
  } else {
    selectedBannerId = "join";
  }
  const selectedBanner = ads[selectedBannerId];

  useEffect(() => {
    if (!selectedBanner) {
      return;
    }

    const selectedBannerTitleKeys = Object.keys(selectedBanner.title);
    const selectedBannerButtonKeys = Object.keys(selectedBanner.button);
    const newSelectedBannerTitle =
      selectedBannerTitleKeys[
        Math.floor(Math.random() * selectedBannerTitleKeys.length)
      ];
    setSelectedBannerTitle(newSelectedBannerTitle);
    const newSelectedBannerButton =
      selectedBannerButtonKeys[
        Math.floor(Math.random() * selectedBannerButtonKeys.length)
      ];
    setSelectedBannerButton(newSelectedBannerButton);
  }, [selectedBanner]);

  if (!selectedBanner) {
    return null;
  }

  return (
    <Box
      sx={{
        ...gradientGrainStyling,
        padding: "12px 16px",
        borderRadius: 3,
        fontSize: 13,
        color: selectedBanner.textColor,
        mt: 4,
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: 20,
        }}
      >
        {selectedBanner.title[selectedBannerTitle]}
      </Typography>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
      >
        <Box>{selectedBanner.body}</Box>
        <Box>
          <img
            src={selectedBanner.img.src}
            alt={selectedBanner.img.alt}
            width={selectedBanner.img.width}
            height={selectedBanner.img.height}
            style={{
              borderRadius: 8,
            }}
          />
        </Box>
      </Stack>
      <Box>
        <Button
          component={Link}
          to={selectedBanner.link}
          onClick={() => {
            analytics.track("cta-click", {
              context: "image_detail",
              action: selectedBannerId,
              title: selectedBannerTitle,
              button_text: selectedBannerButton,
            });
          }}
          variant="outlined"
          color={selectedBanner.buttonColor}
          sx={{
            fontWeight: 700,
            mt: 2,
          }}
          fullWidth
        >
          {selectedBanner.button[selectedBannerButton]}
        </Button>
        <div style={{ fontSize: 10, marginTop: 4, textAlign: "center", width: "100%" }}>
          {selectedBanner.footer}
        </div>
      </Box>
    </Box>
  );
}

export default Banner;
